import { axiosInstanceWithCredentials } from "./base";

export function getTemplates(params) {
    return axiosInstanceWithCredentials.get("/templates", {
        params
    });
}

export function getTemplateDetails(params) {
    return axiosInstanceWithCredentials.get("/template", {
        params
    });
}

export function updateTemplateDetails(data) {
    return axiosInstanceWithCredentials.put(`/template/`,data);
}


export function createTemplate(data) {
    return axiosInstanceWithCredentials.post(`/template/`,data);
}
